import { render, staticRenderFns } from "./StrutturePresidiEditComponent.vue?vue&type=template&id=7e400614"
import script from "./StrutturePresidiEditComponent.vue?vue&type=script&lang=js"
export * from "./StrutturePresidiEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports